import { applyLandingBrand } from "@/lib/siteHosts"

export const leadInterceptionContent = applyLandingBrand({
  title: "Lead Interception Without the Friction",
  body: "Most software forces you to change how you run your business. FractoLabs intercepts leads silently under your existing setup:",
  items: [
    "Without hiring or managing 24/7 sales staff.",
    "Without touching code or complex workflows.",
    "Without increasing your current ad budget.",
    "Without credit cards, retainers, or long-term contracts.",
  ],
})
